import ReactGA from "react-ga4";

export const initializeAnalytics = () => {
    ReactGA.initialize("G-EK1ZJQ54RY"); // Replace with your Tracking ID
};

export const logPageView = () => {
    ReactGA.send("pageview");
};
